import React, { useEffect, useRef } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { navigationCurrent } from '../../lib/site-navigation.mjs'
import { structuredNavArray } from '../../lib/navigationObject'
import fullLogo from '../../public/brand/selong-belanak-wordmark.png'
import { socialsArray } from '../../assets/svg/allSVG'
import { useMenu } from '../../context/menu.context'
import { MenuHamburger } from '../hamburger/hamburger-menu'
import {
  GridContainer_Page_Layout,
  MenuTopBar,
  MenuLogo,
  CloseButton,
  MenuContent,
  MenuIntro,
  MenuGrid,
  MenuGroup,
  GroupHeading,
  MotionUl,
  MotionLi,
  FooterContainer,
  SocialContainer,
  PrivacyContainer,
  NavImage,
} from './side-nav.styles'

const socialLabel = (url = '') => {
  const value = url.toLowerCase()
  if (value.includes('instagram')) return 'Selong Belanak on Instagram'
  if (value.includes('tripadvisor')) return 'Selong Belanak on Tripadvisor'
  return 'Selong Belanak social media'
}

const SideBarMenu = () => {
  const { close } = useMenu()
  const { asPath } = useRouter()
  const closeButtonRef = useRef(null)

  useEffect(() => {
    closeButtonRef.current?.focus()
  }, [])

  return (
    <GridContainer_Page_Layout>
      <MenuTopBar>
        <Link href="/" onClick={close} aria-label="Selong Belanak home">
          <MenuLogo src={fullLogo} alt="Selong Belanak" unoptimized priority />
        </Link>
        <CloseButton ref={closeButtonRef} type="button" onClick={close} aria-label="Close navigation menu">
          <MenuHamburger isOpen />
          <span>Close</span>
        </CloseButton>
      </MenuTopBar>

      <MenuContent>
        <MenuIntro>
          <p>Plan your visit</p>
          <h2>Explore Selong Belanak</h2>
        </MenuIntro>

        <MenuGrid aria-label="Destination guide">
          {structuredNavArray.map((item) => (
            <MenuGroup key={item.id}>
              <GroupHeading>
                <Link href={item.path} onClick={close} aria-current={navigationCurrent(asPath, item.path)} data-analytics-cta-id={item.id === 'surf-forecast' ? 'menu:surf-forecast' : undefined} data-analytics-placement-id={item.id === 'surf-forecast' ? 'expanded-navigation' : undefined}>{item.header}</Link>
              </GroupHeading>
              <MotionUl>
                {item.label.filter(link => link.path !== item.path).map((link) => (
                  <MotionLi key={link.path}>
                    <Link href={link.path} onClick={close} aria-current={navigationCurrent(asPath, link.path)}>{link.header}</Link>
                  </MotionLi>
                ))}
              </MotionUl>
            </MenuGroup>
          ))}
        </MenuGrid>
      </MenuContent>

      <FooterContainer>
        <SocialContainer aria-label="Social media">
          {socialsArray.map(({ Icon, url }) => (
            <Link key={url} href={url} target="_blank" rel="noopener noreferrer" aria-label={socialLabel(url)}>
              <NavImage><Icon /></NavImage>
            </Link>
          ))}
        </SocialContainer>
        <PrivacyContainer>
          <Link href="/contact" onClick={close}>Contact</Link>
          <Link href="/privacy-policy" onClick={close}>Privacy Policy</Link>
          <Link href="/editorial-policy" onClick={close}>Editorial Policy</Link>
          <Link href="/api/sitemap.xml" onClick={close}>Sitemap</Link>
        </PrivacyContainer>
      </FooterContainer>
    </GridContainer_Page_Layout>
  )
}

export { SideBarMenu }
